import AppConstant from '../../../config/app.constants';

class ServiceActionPrioritiesController {
    /*@ngInject*/
    constructor(ServiceActionPrioritiesService, Modal, DateUtil) {
        this.ServiceActionPrioritiesService = ServiceActionPrioritiesService;
        this.Modal = Modal;
        this.DateUtil = DateUtil;

        this.model = {
            priorities: [],
            originalPriorities: [],
            searchText: '',
            loading: true,
            saving: false
        };
        this.pagination = {
            page: 1,
            total: 0,
            pageLimit: 10,
            maxPages: 10
        };
    }

    $onInit() {
        this.loadData();
    }

    addPriority() {
        this.Modal.createServiceActionPriority(({ modal, priorityItem }) => {
            this.model.saving = true;
            this.ServiceActionPrioritiesService.create(priorityItem)
                .then(() => {
                    modal.close();
                    this.loadData();
                })
                .catch((err) => {
                    this.Modal.errorModal(err.data ? err.data.message : 'Error creating Service Action Priority');
                })
                .finally(() => {
                    this.model.saving = false;
                });
        }, ({ modal }) => {
            if (modal) modal.close();
        });
    }

    removePriority(index) {
        this.model.priorities.splice(index, 1);
    }

    loadData() {
        this.model.loading = true;
        this.ServiceActionPrioritiesService.all(this.model.searchText, (this.pagination.page - 1) * this.pagination.pageLimit, this.pagination.pageLimit)
            .then((data) => {
                this.pagination.total = data.total;
                this.model.priorities = angular.copy(data.results);
                this.model.originalPriorities = Object.freeze(angular.copy(data.results));
            })
            .catch((err) => {
                this.Modal.errorModal(err.message);
            })
            .finally(() => {
                this.model.loading = false;
            });
    }

    pageChange() {
        this.loadData();
    }

    disableUpdate() {
        if (!this.model.priorities) return true;
        let emptyRecords = this.model.priorities.filter(i => !i.priority);
        return emptyRecords.length > 0;
    }

    compareArrays(originalArray, changedArray) {
        const changed = [];
        const removed = [];
        const originalMap = new Map();

        originalArray.forEach(item => originalMap.set(item.id, item));
        changedArray.forEach(item => {
            const originalItem = originalMap.get(item.id);
            if (!originalItem) {
                changed.push(item);
                return;
            };

            if (item.priority !== originalItem.priority || item.description !== originalItem.description || item.active !== originalItem.active) {
                changed.push(item);
            }
            originalMap.delete(item.id);
        });

        removed.push(...originalMap.values());
        if (changed.length === 0 && removed.length === 0) {
            return null;
        }
        return { changed, removed };
    }

    updatePriorities() {
        this.model.saving = true;
        const diff = this.compareArrays(this.model.originalPriorities, this.model.priorities);
        if (!diff) {
            this.model.saving = false;
            return;
        }

        let promises = [];
        if (diff.changed && diff.changed.length) {
            diff.changed.forEach(item => {
                if (item.id) {
                    promises.push(this.ServiceActionPrioritiesService.update(item.id, item));
                } else {
                    promises.push(this.ServiceActionPrioritiesService.create(item));
                }
            });
        }
        if (diff.removed && diff.removed.length) {
            diff.removed.forEach(item => {
                if (item.id) promises.push(this.ServiceActionPrioritiesService.remove(item.id));
            });
        }

        Promise.all(promises).then(() => {
            this.loadData();
        }).catch((err) => {
            this.Modal.errorModal(err.data && err.data.message ? err.data.message : 'Error updating Service Action Priorities');
        }).finally(() => {
            this.model.saving = false;
        });
    }

    getUpdatedByLabel(item) {
        if (!item || !item.updatedByUser) return 'N/A';
        const { id, firstName, lastName } = item.updatedByUser;
        const fullName = [firstName, lastName].filter(Boolean).join(' ');
        return id ? `${id} | ${fullName || 'N/A'}` : (fullName || 'N/A');
    }
}

export default ServiceActionPrioritiesController;



// WEBPACK FOOTER //
// ./client/app/components/service_settings/service-action-priorities/service-action-priorities.controller.js